import { motion } from "framer-motion";
import { ShieldCheck, Lightning, GlobeStand, Lifebuoy, ChartLineUp, Handshake } from "@phosphor-icons/react";

const ITEMS = [
    { Icon: ShieldCheck, t: "Audited Safety Culture", d: "ISM, ISPS, MLC, TMSA-compliant. Major-vetted across desks." },
    { Icon: Lightning, t: "Live Charter Desk", d: "Round-the-clock fixtures with real-time voyage estimation." },
    { Icon: GlobeStand, t: "Global Footprint", d: "Singapore HQ + 11 partner hubs across four continents." },
    { Icon: Lifebuoy, t: "Crew First", d: "Trained crews retained on long tenures with industry-leading welfare." },
    { Icon: ChartLineUp, t: "Commercial Discipline", d: "Transparent post-fixture reporting, demurrage and laytime control." },
    { Icon: Handshake, t: "Trusted Charterers", d: "Long-running relationships with NOCs, oil majors and trading houses." },
];

export default function WhyChooseUs() {
    return (
        <section data-testid="why-choose-us" className="relative py-24 md:py-32 bg-[#040914]">
            <div className="wms-container">
                <div className="max-w-2xl">
                    <span className="wms-overline">Why Windermere — 05</span>
                    <h2 className="mt-5 font-display font-light text-4xl md:text-5xl leading-tight tracking-tight">
                        Built for charterers who can't afford to be wrong.
                    </h2>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
                    {ITEMS.map(({ Icon, t, d }, i) => (
                        <motion.div
                            key={t}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.5, delay: i * 0.05 }}
                            className="bg-[#040914] hover:bg-[#0B1324] transition-colors p-8 group"
                            data-testid={`why-item-${i}`}
                        >
                            <div className="flex items-center justify-between">
                                <span className="flex items-center justify-center w-12 h-12 border border-white/10 group-hover:border-[#48CAE4]/40 transition-colors">
                                    <Icon size={22} weight="duotone" className="text-[#48CAE4]" />
                                </span>
                                <span className="text-[11px] tracking-[0.32em] uppercase text-white/30">{String(i + 1).padStart(2, "0")}</span>
                            </div>
                            <h3 className="mt-7 font-display text-lg text-white">{t}</h3>
                            <p className="mt-3 text-sm text-white/55 leading-relaxed">{d}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
